import { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Select from "react-dropdown-select";

import PaginationWithControls from "../PaginationWithControls";

interface appCategoriesRelationshipDetail {
  appCategoryId: number;
  categoryId: number;
  stateId: number;
  stateName: string;
  categoryName: string;
}

interface ListCategoryDetailProps {
  appCategoriesRelationshipList: appCategoriesRelationshipDetail[];
  resetFindOptions: () => void;
  findOptions: any;
  stateListForDropdown: {
    stateName: string;
    stateId: number;
  }[];
  categoryListForDropdown: {
    categoryName: string;
    categoryId: number;
  }[];
  handleFind: (findOptions: any) => void;
  handelDelete: (
    appCategoryId: number,
    stateId: number,
    categoryId: number
  ) => void;
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
}

const ListAppCategoryDetail: React.FC<ListCategoryDetailProps> = ({
  appCategoriesRelationshipList,
  resetFindOptions,
  findOptions,
  stateListForDropdown,
  categoryListForDropdown,
  handleFind,
  handelDelete,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  onChangePageSize,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handelClearParameter = () => {
    setSearchOptions({
      categoryId: null,
      stateId: null,
    });
    resetFindOptions();
  };

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  };
  const onClickFind = (findOptions: any) => {
    handleFind(findOptions);
    handleModalClose();
  };

  return (
    <>
      <div className="float-end">
        <Button
          variant="primary"
          className="ml-1 mb-3"
          onClick={handleModalOpen}
        >
          Find Options
        </Button>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find App Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              className="mb-3"
              variant="secondary"
              onClick={() => handelClearParameter()}
            >
              Clear Parameters
            </Button>
            <Form>
              <Form.Group className="mb-3" controlId="findState">
                <Form.Label>Category</Form.Label>
                <Select
                  options={categoryListForDropdown}
                  labelField="categoryName"
                  valueField="categoryId"
                  searchable
                  searchBy={"categoryName"}
                  onChange={(values) =>
                    onChangeFieldValue({ categoryId: values[0]?.categoryId })
                  }
                  values={[]}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="findState">
                <Form.Label>State</Form.Label>
                <Select
                  options={stateListForDropdown}
                  labelField="stateName"
                  valueField="stateId"
                  searchable
                  searchBy={"stateName"}
                  onChange={(values) =>
                    onChangeFieldValue({ stateId: values[0]?.stateId })
                  }
                  values={[]}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => onClickFind(searchOptions)}
            >
              Find
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Website Categories</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {appCategoriesRelationshipList.map(
            (relationship: appCategoriesRelationshipDetail, index: number) => (
              <tr key={index}>
                <td>{relationship.categoryName}</td>
                <td>{relationship.stateName}</td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() =>
                      handelDelete(
                        relationship.appCategoryId,
                        relationship.categoryId,
                        relationship.stateId
                      )
                    }
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </Table>
      {appCategoriesRelationshipList.length > 0 ? (
        <>
          <PaginationWithControls
            pageIndex={pageIndex}
            pageSize={pageSize}
            listCount={totalItemCount}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
          />
        </>
      ) : (
        <p className="text-center py-3">No results found</p>
      )}
    </>
  );
};

export default ListAppCategoryDetail;
